function Footer() {
	return (
		<footer className="footer float-end">
          <p className="mb-0" style={{color: "#519d00"}}> Powered by <a style={{color: "#519d00"}} href='https://aoholdings.net' target='_blank' rel="noopener noreferrer">AO HOLDINGS</a></p>
        </footer>
	);
}

export default Footer;